export default "__VITE_ASSET__$E4OZPEz__"